import { BookingLocationType } from "@clockwise/schema";
import { ConfirmationType } from "@ui/scheduling-confirmation";
import { EventSummary } from "@ui/scheduling-confirmation/event-summary";
import { asMinutes } from "@util/date.util";
import React from "react";

export type Booking = {
  startTime: string;
  endTime: string;
  ownerEmail: string;
  attendeeEmail: string;
  locationType: BookingLocationType;
  meetingName: string;
  description: string | null;
};

type Props = {
  booking: Booking;
  newDateTime?: string;
  timeZone: string;
  compact?: boolean;
};

/**
 * Given an existing booking for a Scheduling Link, display it in the same EventSummary form that
 * is used when creating the booking.
 */
export function CurrentBookingDetails({ booking, newDateTime, timeZone, compact }: Props) {
  return (
    <EventSummary
      compact={compact}
      title={booking.meetingName}
      duration={asMinutes(booking)}
      prevDateTime={newDateTime ? booking.startTime : null}
      attendees={[booking.ownerEmail, booking.attendeeEmail]}
      dateTime={newDateTime || booking.startTime}
      location={booking.locationType}
      description={booking.description}
      variant={ConfirmationType.Reschedule}
      timeZone={timeZone}
    />
  );
}
